import Vue from "vue";
import store from "../../../store";

export const DispatchRequestsBase = Vue.extend({

    computed: {
        salesOrderLinesById() {
            return _.keyBy(this.salesOrder.sales_order_lines, line => line.id)
        },
    },

    methods: {
        dispatchersForSelectedDispatcherType(dispatchRequest) {
            try {
                const locations = this.$store.state.allLocations.length
                    ? this.$store.state.allLocations
                    : this.relevantLocations

                return _.sortBy(
                    locations
                        .filter(location => {
                            return location.location_type.identifier === dispatchRequest.dispatcher_type
                                && (
                                    dispatchRequest.id
                                    || (!dispatchRequest.id && location.active)
                                )
                        }),
                    'display_name'
                )
            } catch (e) {
                console.error(e)
                return []
            }
        },
        getDispatcher(dispatchRequest) {
            return this.dispatchersForSelectedDispatcherType(dispatchRequest)
                .find(type => type.identifier.toString() === dispatchRequest.dispatcher_identifier)
        },
        getDispatcherName(dispatchRequest) {
            try {
                return this.getDispatcher(dispatchRequest)
                    .display_name
            } catch (e) {
                return dispatchRequest.dispatcher_identifier
            }
        },
        getDispatcherType(dispatchRequest) {
            try {
                return this.getDispatcher(dispatchRequest)
                    .location_type.display_name
            } catch (e) {
                return dispatchRequest.dispatcher_type
            }
        },
        getReturnReason(id) {
            const reason = this.$store.state.returnReasons.find(r => r.id === id)
            return reason ? reason : {}
        },
        getProductState(id) {
            const state = this.$store.state.productStates.find(s => s.id === id)
            return state ? state : {}
        },
        getSalesOrderLine(id) {
            return this.salesOrderLinesById[id]
                ? this.salesOrderLinesById[id]
                : {
                    promotions: [],
                }
        },
        showDispatchRequestDeliveryFields(dispatchRequest) {
            return [
                'return-announced',
                'return-scan-in-process',
                'return-received',
                'unable-to-ship',
                'unable-to-ship-final',
                'cancelled',
                'shipped-with-issues',
            ].indexOf(dispatchRequest.status) === -1
        },
        showDispatchFields(dispatchRequest) {
            const showForStatuses = store.state.config.settings['frontend-parameters.dispatch-requests']?.['show-dispatch-fields-only-for-drq-statuses'] ?? ''
            if (!showForStatuses.trim().length) {
                return true
            }

            return showForStatuses.split(',').includes(dispatchRequest.status)
        },
    }
})
